import { HasId } from "./PropertyFacade";
import { PropertyStripLayout } from "./PropertyStripLayout";

export type HasIdAndLockable = HasId & { locked: boolean };

export const lockedLayout = PropertyStripLayout<HasIdAndLockable>((d, s, o, w, a) => [
    w.createButton({
        image: 'deqo://icons/d2/unlocked',
        text: 'Unlock',
        onAction() {
            o.update(() => a.set('locked', false));
        },
    })
]);

export const LockablePropertyStripLayout = <T extends HasIdAndLockable>(psl: PropertyStripLayout<T>) =>
    PropertyStripLayout<T>((d, s, o, w, a) => {
        if (a.get('locked') !== false) {
            return lockedLayout(d, s, o, w, a);
        }
        return [
            ...psl(d, s, o, w, a),
        ];
    });